import {LocaleCode, UserId, UserType, BaseUser, PathologyId} from '@legit-health/ui';
import PrivateInsuranceProvider from '@/shared/interfaces/PrivateInsuranceProvider';
import Practitioner from './Practitioner';

export default class Patient implements BaseUser {
  constructor(
    readonly id: UserId,
    readonly name: string,
    readonly surname: string,
    readonly secondSurname: string | null,
    readonly gender: string | null,
    readonly locale: LocaleCode,
    readonly fullname: string,
    readonly country: string | null,
    readonly email: string | null,
    readonly image: string | null,
    readonly imageThumbnail: string | null,
    readonly is2faEnabled: boolean,
    readonly hasCompletedTutorial: boolean,
    readonly enableExperimentalFeatures: boolean,
    readonly lastLogin: string | null,
    readonly allowsReceiveEmails: boolean,
    readonly type: UserType,
    readonly birthDate: string | null,
    readonly telephone: string | null,
    readonly emergencyContact: string | null,
    readonly address: string | null,
    readonly languages: string | null,
    readonly careGaps: string | null,
    readonly socialDeterminants: string | null,
    readonly skinType: string | null,
    readonly riskFactors: string | null,
    readonly allergies: string | null,
    readonly weight: string | null,
    readonly height: string | null,
    readonly nhc: string | null,
    readonly idCard: string | null,
    readonly healthCenter: string | null,
    readonly healthCardNumber: string | null,
    readonly privateInsuranceProvider: PrivateInsuranceProvider,
    readonly habits: string | null,
    readonly practitioner: Practitioner,
    readonly referredToPractitioners: UserId[],
    readonly canViewResultsOfDiagnosticReports: boolean,
    readonly isAllowedToUploadPhotos: boolean,
    readonly assignedPathologies: PathologyId[],
    readonly isMobileOnlyPhotoEnabled: boolean
  ) {}
}
